export enum EventType {
    PAGE_VIEW = "page_view",
    WIDGET_VIEW = "widget_view",
    LOGIN_SUCCESS = "login_success",
    LOGIN_FAILED = "login_failed",
    LOGOUT = "logout",
    SIGNUP = "signup",
    BUTTON_CLICK = "button_click",
    CLICK = "click",
    CHANGE_PASSWORD_REQUEST_SUCCESS = "change_password_request_success",
    CHANGE_PASSWORD_REQUEST_FAILED = "change_password_request_failed",
    CHANGE_PASSWORD_RESEND_CODE_SUCCESS = "change_password_resend_code_success",
    CHANGE_PASSWORD_RESEND_CODE_FAILED = "change_password_resend_code_failed",
    CHANGE_PASSWORD_SUCCESS = "change_password_success",
    CHANGE_PASSWORD_FAILED = "change_password_failed",
    REGISTRATION_STARTED = "registration_started",
    REGISTRATION_FAILED = "registration_failed",
    REGISTRATION_RESEND_CODE_SUCCESS = "registration_resend_code_success",
    REGISTRATION_RESEND_CODE_FAILED = "registration_resend_code_failed",
    REGISTRATION_COMPLETED = "registration_completed",
    PRODUCT_FOUND = "product_found",
    PRODUCT_NOT_FOUND = "product_not_found",
    PRODUCT_SAVED = "product_saved",
    PRODUCT_NOT_SAVED = "product_not_saved",
    SWABCODE_SAVED = "swabcode_saved",
    SWABCODE_NOT_SAVED = "swabcode_not_saved",
}